import LayoutData from '../../../data/LayoutData';
import Boundaries from '../../../helper/cutDesign/Boundaries';
import calcBoundary from '../../../helper/cutDesign/boundary';
import { unitChange } from '../../../helper/mathHelper';
import { ALL_PINS, getComponentPinLocation, PIN_GROUP, SINGLE_PIN, WAVE, AutoGeneratePorts } from '../../../ExtractionPortsHelper';
import DesignInfo from '../../pcbInfo';

export function getSelectNets(signals) {
  const names = signals.map(d => d.nets).flat();
  return names;
}

export function getNetsBoundaryArr({ clipSize, signals, designId }) {
  const db = LayoutData.getLayout(designId);
  const boundaries = new Boundaries({ layoutDB: db, distance: updateDistance(clipSize, db.mUnits), clipSize });
  let arr = [];
  getSelectNets(signals).forEach(net => {
    arr.push({ net, boundary: boundaries.getNetBoundary(net) });
  });
  return arr;
}

export function generateBoundaryList({ clipSize, signals, designId, port_setups = [], ports_generate_setup_list = [], referenceNets = [] }) {
  if (!signals.length) return null;
  const db = LayoutData.getLayout(designId);
  if (!db) return {};
  let _unit = db.mUnits;
  if (_unit === "mils") {
    _unit = "mil";
  }
  let maxX = Infinity, maxY = Infinity, minX = -Infinity, minY = -Infinity;
  if (db.mProfile && db.mProfile.mVertices && db.mProfile.mVertices.length) {
    const mXArr = db.mProfile.mVertices.map(d => d.mX);
    const mYArr = db.mProfile.mVertices.map(d => d.mY);
    maxX = Math.max(...mXArr);
    maxY = Math.max(...mYArr);
    minX = Math.min(...mXArr);
    minY = Math.min(...mYArr);
  }

  const _port_setups = JSON.parse(JSON.stringify(port_setups));
  const _ports_generate_setup_list = JSON.parse(JSON.stringify(ports_generate_setup_list));
  const _clipSize = clipSize;
  const refPortBoundaryArr = getReferencePortBoundaryArr({
    clipSize: _clipSize,
    port_setups: _port_setups,
    ports_generate_setup_list: _ports_generate_setup_list,
    designId,
    referenceNets
  });
  // BoundaryArr[[x1, y1], [x2, y2]]
  const netBoundaryArr = getNetsBoundaryArr({ clipSize: _clipSize, signals, designId });
  const verticesArr = getVerticesArr([...netBoundaryArr, ...refPortBoundaryArr]);
  const data = calcBoundary(verticesArr, _clipSize, _unit, { maxX, maxY, minX, minY }, [...netBoundaryArr, ...refPortBoundaryArr]);
  return { data, boundaryPoints: { maxX, maxY, minX, minY } };
}

function getVerticesArr(vertices) {
  const _netsVertices = [...vertices];

  let _vertices = [];
  for (let item of _netsVertices) {
    const { boundary } = item;
    _vertices = _vertices.concat(boundary);
  }

  let obj = {};
  _vertices = _vertices.filter(item => {
    if (!obj[item.toString()]) {
      obj[item.toString()] = true;
      return item;
    }
    return false;
  });

  return _vertices;
}

export function getReferencePortBoundaryArr({ clipSize, port_setups, ports_generate_setup_list, designId, referenceNets }) {
  const db = LayoutData.getLayout(designId);
  const boundaries = new Boundaries({ layoutDB: db, distance: updateDistance(clipSize, db.mUnits), clipSize });

  const refPins = getReferencePins({ port_setups, ports_generate_setup_list, designId, referenceNets });
  let arr = [];
  for (const compInfo of refPins) {
    const compPins = getComponentPinLocation({
      scaling: 1,
      component: db.getComponent(compInfo.comp),
      compName: compInfo.comp,
      mPartMgr: db.mPartMgr,
      savePad: true
    }).filter(d => compInfo.pins.includes(d.number))
    arr.push(...boundaries.getPinsBoundaryArr(compPins));
  }
  return arr;
}

export function updateDistance(clipSize, unit) {
  let _unit = unit;
  if (_unit === "mils") {
    _unit = "mil";
  }
  const { number } = unitChange({ num: parseFloat(clipSize), oldUnit: 'mm', newUnit: _unit, decimals: 12 });
  return parseFloat(number);
}

function getReferencePins({ port_setups, ports_generate_setup_list, designId, referenceNets }) {
  let arr = [];  // { refCompPin }
  let reGenerate = false;
  let _port_setups = [...port_setups];
  let _ports_generate_setup_list = [...ports_generate_setup_list];
  _ports_generate_setup_list.forEach(d => {
    const portType = d.setup.portType;
    const referenceType = d.setup.referenceType;
    if (portType === WAVE || referenceType === ALL_PINS) {
      d.setup.portType = PIN_GROUP;
      d.setup.referenceType = SINGLE_PIN;
      reGenerate = true;
    }
  });
  if (reGenerate) {
    const data = (new AutoGeneratePorts()).autoGeneratePorts(
      port_setups,
      DesignInfo.getPCBInfo(designId),
      {
        ports_generate_setup_list: _ports_generate_setup_list,
        designId,
        referenceNets,
        referenceZ0: "50"
      });

    _port_setups = JSON.parse(JSON.stringify(data.port_setups));
  }

  let compObj = {};
  function addPin(comp, pins) {
    if (compObj[comp] === undefined) {
      compObj[comp] = arr.length;
      arr[compObj[comp]] = new refCompPin(comp, pins);
    } else {
      arr[compObj[comp]].addPins(pins);
    }
  }

  for (const port of _port_setups) {
    if (!port.negative) continue;
    if (port.negative.PINS_INFO) {
      for (const info of port.negative.PINS_INFO) {
        addPin(info.component, [info.pin])
      }
    } else if (port.negative.component && port.negative.pin) {
      addPin(port.negative.component, [port.negative.pin])
    }
  }
  return arr;
}

function refCompPin(comp, pins) {
  this.comp = comp; // String
  this.pins = pins; // Array[String]
}

// pins/pin Array/String
refCompPin.prototype.addPins = function (pins) {
  this.pins = [...new Set(this.pins.concat(pins))]; // remove duplicates pins
}

export default {
  getSelectNets
}